export default function tables() {

    const tables = document.querySelectorAll('.content-cms table');

    if (tables.length > 0) {

        tables.forEach(table => {
            let code = table.outerHTML;
            table.outerHTML = `<div class="table-wrapper">${code}</div>`;
        });

    }

}